import React from 'react'
import { Helmet } from 'react-helmet'
import Layout from '../../components/layouts/Layout'
import AboutSection from '../../components/AboutSection'
import TeamSection from '../../components/TeamSection'
import about from "../../assets/about.png"

function AboutUs() {
    return (
        <div>
            <Helmet> <title>Kaanshi Films Entertainment (KFE) | Film & Video Production House Mumbai | About Us Page</title> </Helmet>
            <Layout>
                <div className="">
                    <img src={about} height={200} className='h-[500px] w-full  object-fill' alt="" />
                </div>

             <AboutSection/>
         <TeamSection/>



            </Layout>
        </div>
    )
}

export default AboutUs
